import { NextSeo, WebPageJsonLd } from "next-seo";
import { Navbar } from "~/components/Navbar/component";
import { PageWrapper, SidebarLayout } from "~/components/SidebarLayout";
import { SOCIAL_OG_IMAGE_URL } from "~/consts";
import { PageTrack } from "~/modules/analytics/components/PageTrack";
import { addBaseUrl } from "~/modules/app/seo/addBaseUrl";
import { BreadcrumbSEO } from "~/modules/app/seo/BreadcrumbSEO";
import { AboutPage } from "~/modules/legal/pages/about";
import { UserFetcher } from "~/modules/user/components/UserFetcher";
import { Routes } from "~/routes";

// // // //

const SEO_TITLE = "About";
const SEO_DESCRIPTION =
    "At RWA.xyz, we are hyper-focused on delivering the clearest insights into the tokenized real-world asset (RWA) market.";

// // // //

export default function About() {
    return (
        <PageTrack>
            <NextSeo
                title={SEO_TITLE}
                description={SEO_DESCRIPTION}
                canonical={addBaseUrl(Routes.about)}
                openGraph={{
                    type: "website",
                    url: addBaseUrl(Routes.about),
                    title: SEO_TITLE,
                    site_name: "RWA.xyz",
                    description: SEO_DESCRIPTION,
                    images: [
                        {
                            url: SOCIAL_OG_IMAGE_URL,
                            width: 4000,
                            height: 2300,
                            alt: "rwa.xyz",
                        },
                    ],
                }}
                // additionalMetaTags={[
                //     {
                //         name: "keywords",
                //         content:
                //             "At RWA.xyz, we are hyper-focused on delivering the clearest insights into the tokenized real-world asset (RWA) market.",
                //     },
                // ]}
            />
            <WebPageJsonLd
                id={addBaseUrl(Routes.about)}
                description={SEO_DESCRIPTION}
                reviewedBy={{
                    type: "Organization",
                    name: "RWA.xyz",
                }}
            />
            <BreadcrumbSEO
                items={[
                    {
                        name: SEO_TITLE,
                        href: Routes.about,
                    },
                ]}
            />
            <UserFetcher>{({ user }) => <Navbar user={user} />}</UserFetcher>
            <SidebarLayout pathname={Routes.about} showFooter>
                <PageWrapper>
                    <AboutPage />
                </PageWrapper>
            </SidebarLayout>
        </PageTrack>
    );
}
